<a
  class="skip-link"
  href="#main-content"
  (click)="skipToMainContent($event)"
  (keydown.enter)="skipToMainContent($event)"
  >
  {{ "ACCESSIBILITY.SKIP_TO_MAIN" | translate }}
</a>
<div>
  <app-loading-spinner></app-loading-spinner>
  <app-analytics></app-analytics>

  <!-- Router content - main content ID will be added by individual pages -->
  <router-outlet></router-outlet>

  @if (showVideoConsultationLegalLinks) {
    <div class="legal-links">
      <app-footer-legal-links />
    </div>
  }

  <app-modal role="dialog" aria-live="polite"></app-modal>
</div>
